import MonthNavigatorComponent from './month-navigator-component';

/***
 * a reusable pair of dropdown lists that allow you to select a month and a year.
 */
const monthNavigator = angular
    .module('FacilityData.Common.MonthNavigator', [])
    .component('monthNavigator', MonthNavigatorComponent)
    .name;

export default monthNavigator;


// WEBPACK FOOTER //
// ./app/common/month-navigator/month-navigator.js